export default "__VITE_ASSET__CX_z6rKw__"